import useUserPermissions from './useUserPermissions';
import { DEFAULT_PERMISSIONS_LIST } from '../constants/permissionsList';

function usePermissionStatus(type = DEFAULT_PERMISSIONS_LIST) {
  const { data: permissions = [] } = useUserPermissions(type);

  const getPermissionStatus = (key) => {
    const permission = permissions.find((perm) => perm.key === key);

    return permission?.status ?? null;
  };

  return { getPermissionStatus };
}

export default usePermissionStatus;
